import React from 'react';
import PropTypes from 'prop-types';
import { StyledCard } from './style';

const CardReportInfo = ({
    titleCaps,
    text,
    classComponent,
}) => (
	<StyledCard className={classComponent}>
		<div className="text-title d-flex justify-content-center align-items-center">
			<h4>{titleCaps}</h4>
		</div>
		<div className="content-body d-flex justify-content-center align-items-center">{text}</div>
	</StyledCard>
);

PropTypes.Card = {
	titleCaps: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	classComponent: PropTypes.string,
};

export default CardReportInfo;
